import img from '../assets/wallet-img.webp';
import gif from '../assets/gif2.gif';

const sections = [
  {
    tag: 'Digital Wallet',
    title: 'One wallet.\nInfinite possibilities.',
    desc: 'Deposit and withdraw euros using your IBAN account. Send, receive, and swap cash effortlessly from a single, elegant interface.',
    img: img,
    imgRight: true,
    accent: 'from-violet-500 to-indigo-500',
  },
  {
    tag: 'Send & Receive',
    title: 'Money moves at the speed of a message.',
    desc: 'All you need is a mobile number or QR code to send crypto and EUR. Transactions are free when sender and receiver use the same currency.',
    img: gif,
    imgRight: false,
    accent: 'from-cyan-500 to-blue-500',
  },
  {
    tag: 'Convert',
    title: 'Convert anything. Instantly.',
    desc: 'Seamlessly convert crypto to crypto, or crypto to EUR and vice versa. Choose from a wide range of cryptocurrencies with the best rates.',
    img: gif,
    imgRight: true,
    accent: 'from-orange-500 to-pink-500',
  },
  {
    tag: 'Easy Swap',
    title: 'Auto-receive in your preferred crypto.',
    desc: 'Automatically receive payments in the crypto of your choice with our Easy Swap Engine. Secure and effortless to set up in minutes.',
    img: img,
    imgRight: false,
    accent: 'from-emerald-500 to-teal-500',
  },
];

function About() {
  return (
    <section className="bg-[#080812] py-16">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-24">
          <span className="inline-block text-violet-400 text-sm font-bold tracking-widest uppercase mb-4">Platform Features</span>
          <h2 className="text-4xl lg:text-6xl font-black text-white leading-tight">
            Everything you need,<br />
            <span className="bg-gradient-to-r from-violet-400 to-cyan-400 bg-clip-text text-transparent">nothing you don't.</span>
          </h2>
        </div>

        <div className="space-y-32">
          {sections.map((s, i) => (
            <div key={i} className={`flex flex-col ${s.imgRight ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-16`}>
              {/* Text */}
              <div className="flex-1">
                <span className={`inline-block text-xs font-bold tracking-widest uppercase px-3 py-1.5 rounded-full bg-gradient-to-r ${s.accent} text-white mb-5`}>
                  {s.tag}
                </span>
                <h3 className="text-3xl lg:text-5xl font-black text-white leading-tight mb-6 whitespace-pre-line">
                  {s.title}
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed mb-8 max-w-lg">
                  {s.desc}
                </p>
                <button className={`group inline-flex items-center gap-3 bg-gradient-to-r ${s.accent} text-white font-bold px-7 py-3.5 text-xs rounded-2xl hover:opacity-90 transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5`}>
                  Explore Now
                  <span className="transition-transform group-hover:translate-x-1">→</span>
                </button>
              </div>

              {/* Image */}
              <div className="flex-1 flex justify-center">
                <div className="relative">
                  <div className={`absolute -inset-6 bg-gradient-to-r ${s.accent} opacity-10 blur-3xl rounded-3xl`}></div>
                  <div className="relative bg-white/5 border border-white/10 rounded-3xl p-2 backdrop-blur-sm">
                    <img src={s.img} alt={s.tag} className="w-full max-w-sm rounded-2xl" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;